import Modal from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import Button from "@insite/mobius/Button";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import React from "react";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { css } from "styled-components";

interface Props {
    isOpen: boolean;
    onClose?: () => void;
    closeable?: boolean;
}

const BrandAccessDeniedModal: React.FC<Props> = ({ isOpen, onClose, closeable = true }) => {
    const handleRequestAccess = () => {
        window.location.href = "/Website-Registration";
    };

    const handleBackToPreviousPage = () => {
        // Close the modal first to reset state before navigation
        // This prevents the modal from appearing again when browser restores page state
        if (onClose) {
            onClose();
        }
        
        // Use setTimeout to ensure state update completes before navigation
        setTimeout(() => {
            if (window.history.length > 1) {
                window.history.back();
            } else {
                window.location.href = "/";
            }
        }, 0);
    };

    return (
        <Modal
            headline={translate("Additional Access Required")}
            isOpen={isOpen}
            handleClose={closeable ? onClose : undefined}
            isCloseable={closeable}
            size={700}
            closeButtonProps={{
                css: css`
                    background: transparent !important;
                    border: none !important;
                    outline: none !important;
                    box-shadow: none !important;
                    padding-right: 0 !important;
                    
                    &:hover,
                    &:focus,
                    &:active,
                    &:focus-visible {
                        background: transparent !important;
                        background-color: transparent !important;
                        border: none !important;
                        outline: none !important;
                        box-shadow: none !important;
                    }
                    
                    &::before,
                    &::after {
                        display: none !important;
                    }
                    
                    svg,
                    svg * {
                        outline: none !important;
                        box-shadow: none !important;
                    }
                    
                    * {
                        outline: none !important;
                        box-shadow: none !important;
                        border: none !important;
                    }
                `,
            }}
            cssOverrides={{
                headlineTypography: css`
                    font-size: 24px;
                    font-weight: 600;
                    margin: 0;
                `,
                modalTitle: css`
                    border: 0;
                    padding: 20px 24px 20px 24px;
                    margin-bottom: 0;
                `,
                modalBody: css`
                    overflow: visible;
                    padding: 0;
                    margin-top: 0;
                `,
                modalContent: css`
                    overflow: visible;
                    padding:  0 24px 32px 24px;
                    margin-top: 0;
                `,
            }}
        >
            <StyledWrapper
                css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    opacity: 1;
                    padding: 0;
                `}
        >
                <Typography style={{ margin: 0 }}>
                {siteMessage("SignInInfo_BrandAccessDenied")}
            </Typography>
                <StyledWrapper
                    css={css`
                        display: flex;
                        flex-wrap: wrap;
                        gap: 20px;
                    `}
                >
                    <Button
                        onClick={handleRequestAccess}
                        variant="primary"
                        css={css`
                            height: 44px;
                        `}
                    >
                        {translate("Request Access")}
                    </Button>
                    <Button
                        onClick={handleBackToPreviousPage}
                        variant="secondary"
                        css={css`
                            width: 219px;
                            height: 44px;
                        `}
                    >
                        {translate("Back to Previous Page")}
                    </Button>
                </StyledWrapper>
            </StyledWrapper>
        </Modal>
    );
};

export default BrandAccessDeniedModal;
